export default "__VITE_ASSET__Dx4LrQA8__"